import React from 'react';
import './DispatchBoard.scss';
import { CardBody, CardTitle } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cls from 'classnames';
import {
    faMinusCircle,
    faUser,
} from '@fortawesome/free-solid-svg-icons';
import { Droppable } from '@hello-pangea/dnd';
import { ConfirmationStatus } from '../cancelConfirmation/CancelConfirmation';

export default class DriverJobAssignment extends React.Component {
    render() {
        const {
            job, day, group, jobIndex, assignmentIndex,
        } = {
            ...this.props,
        };
        const dayInt = day.getDay();
        const dropId = `staff_${jobIndex}_${dayInt}_${assignmentIndex}`;


        var equipmentAssignment = null;
        var assignedEquipment = '';
        for (var i = 0; i < job.assignments[dayInt].equipment.length; i++) {
            var eq = job.assignments[dayInt].equipment[i];
            var staff = job.assignments[dayInt].staff[assignmentIndex];
            if (eq.assignedEmployee?.id != null && eq.assignedEmployee?.id == group.assignment?.id) {
                assignedEquipment = eq.assignment.description; 
                equipmentAssignment = eq;
                break;
            }

            if (eq.isBroker && staff.isBroker) {
                assignedEquipment = eq.description;
                equipmentAssignment = eq;
                break;
            }
        }


        return (
            <div key={dropId} className="jobAssignment">
                <Droppable droppableId={dropId} style={{ transform: 'none' }}>
                    {(provided, snapshot) => (
                        <div
                            className="assignment-placeholder-row"
                            style={{ height: '50px !important' }}
                        >
                            <label className="dropPlaceholder">
                                <FontAwesomeIcon
                                    icon={faUser}
                                    className="mr-1"
                                />
                            </label>
                            <div
                                className={cls('jobAssignmentDropTarget', {
                                    dragging: snapshot.isDraggingOver,
                                    show:
                                        !group.assignment
                                        || !!snapshot.isDraggingOver,
                                })}
                                {...provided.droppableProps}
                                ref={provided.innerRef}
                            >
                                {!!group.assignment && (
                                    <div className="card staffCard compact">
                                        <CardBody>
                                            <CardTitle className="text-left d-flex flex-row align-items-center">
                                                <table width='100%'> 
                                                    <tr>
                                                        <td style={{ border: 0, padding: 0 }}>
                                                            <span className="d-flex flex-row align-items-center">

                                                                {!group.assignment &&
                                                                    <label className="mr-1 dropPlaceholder">{`${group.name}`}</label>
                                                                }

                                                                <div className="d-flex flex-column">
                                                                    <table>
                                                                        <tr>
                                                                            <td style={{ border: 0, padding: 0, verticalAlign: 'middle' }}>
                                                                                {
                                                                                    // job.canEdit is backed by whether or not the crew has submitted a timesheet.
                                                                                    // if we have a timesheet for this crew for this day, we cannot remove the assignment.
                                                                                    group.assignment
                                                                                        .confirmationStatusId
                                                                                    != ConfirmationStatus.CancelPending
                                                                                    && !!job.assignments[
                                                                                        dayInt
                                                                                    ].canEdit && (
                                                                                        <>
                                                                                            <FontAwesomeIcon
                                                                                                title="Remove this personnel"
                                                                                                icon={
                                                                                                    faMinusCircle
                                                                                                }
                                                                                                style={{ marginRight: '10px' }}
                                                                                                className="text-danger cursor-pointer"
                                                                                                onClick={() => this.props.onRemoveAssignment(
                                                                                                    job,
                                                                                                    group,
                                                                                                    dayInt,
                                                                                                )}
                                                                                            />

                                                                                        </>
                                                                                    )
                                                                                }
                                                                            </td>
                                                                            <td style={{ border: 0, padding: 0, textAlign: 'left' }}>
                                                                                <div>
                                                                                    <span>
                                                                                        {group.assignment.name}
                                                                                    </span>
                                                                                </div>
                                                                                <span
                                                                                    className={`assignment-status-label ${group.assignment.confirmationStatusName
                                                                                        .replace(
                                                                                            ' ',
                                                                                            '',
                                                                                        )
                                                                                        .toLowerCase()}`}
                                                                                >
                                                                                    {
                                                                                        group.assignment
                                                                                            .confirmationStatusName
                                                                                    }
                                                                                </span>
                                                                            </td>

                                                                            
                                                                        </tr>
                                                                    </table>
                                                                    
                                                                    
                                                                </div>
                                                            </span>
                                                            
                                                        </td>

                                                        {assignedEquipment.length > 0 &&
                                                            <td style={{ border: 0, padding: 0, verticalAlign: 'middle', textAlign: 'right', paddingRight: '4px' }}>


                                                                <table>
                                                                    <tr>
                                                                        <td width='100%' style={{ border: 0, padding: 0, verticalAlign: 'middle', textAlign: 'right' }} >

                                                                            {!eq.isBroker &&
                                                                                <span>
                                                                                    {assignedEquipment}&nbsp;<span style={{ fontWeight: 'bold', color: '#909090' }}>({equipmentAssignment.assignment?.equipmentType?.description})</span>
                                                                                </span>
                                                                            }

                                                                            {eq.isBroker &&
                                                                                <span>
                                                                                    {assignedEquipment}&nbsp;<span style={{ fontWeight: 'bold', color: '#909090' }}></span>
                                                                                </span>
                                                                            }


                                                                            <div>
                                                                                <span
                                                                                    className={`text-right assignment-status-label ${equipmentAssignment.assignment.confirmationStatusName
                                                                                        .replace(' ', '')
                                                                                        .toLowerCase()}`}
                                                                                >
                                                                                    {equipmentAssignment.assignment.confirmationStatusName}
                                                                                </span>
                                                                            </div>
                                                                        </td>

                                                                        <td style={{ border: 0, padding: 0, verticalAlign: 'middle' }}>
                                                                            <FontAwesomeIcon
                                                                                title="Remove this equipment"
                                                                                icon={faMinusCircle}
                                                                                size="lg"
                                                                                className="text-danger cursor-pointer"
                                                                                style={{ marginLeft: '8px' }}
                                                                                onClick={() => {
                                                                                    this.props.onRemoveAssignment(
                                                                                        job,
                                                                                        equipmentAssignment,
                                                                                        dayInt,
                                                                                    );
                                                                                }}
                                                                            />
                                                                        </td>
                                                                    </tr>
                                                                </table>
                                                               
                                                            </td>
                                                        }
                                                    </tr>
                                                </table>
                                                
                                                
                                            </CardTitle>
                                        </CardBody>
                                    </div>
                                )}
                                {
                                    // map qualifying group and roles for display
                                    !group.assignment && (
                                        <div className="dropPlaceholderWrapper">
                                            <label className="dropPlaceholder mr-1">
                                                {group.name}
                                            </label>
                                            {group.assignableGroups.map((g) => (
                                                <span
                                                    title={g.groupName}
                                                    key={g.id}
                                                    className="badge badge-lg badge-secondary mr-1"
                                                >
                                                    {g.groupName
                                                        .charAt(0)
                                                        .toUpperCase()}
                                                </span>
                                            ))}
                                        </div>
                                    )
                                }
                                {provided.placeholder}
                            </div>
                        </div>
                    )}
                </Droppable>
            </div>
        );
    }
}
